import { request } from '../lib/http'

export function fetchVehicleEvolution () {
  return request({
    url: 'vehicle-evolution',
    method: 'get'
  })
}
